import { Flex, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import List from '@/components/List/List';
import Modal from '@/components/Modal/Modal';
import { MainText, SectionTitle } from '@/components/Typography/NamedTypo';
import AddSearchTabModal from '@/features/GlobalSearch/components/GlobalSearchDetail/AddSearchTabModal';
import {
  defaultGlobalSearchConfig,
  type GLOBAL_SEARCH_VIEW,
  GlobalSearchViewConfigMap,
} from '@/features/GlobalSearch/types/searchConst';
import useFetch from '@/hooks/pure/useFetch';
import useModalState from '@/hooks/pure/useModalState';
import { Table } from '@/shared/ui';
import useGlobalSearchStore from '@/stores/GlobalSearchStore';
import { usePopup } from '@/stores/pure/PopupStore';

import SettingHeader from '../Header';

const SearchSettingBody = () => {
  const syncSearchView = useGlobalSearchStore((state) => state.syncSearchView);
  const config = useGlobalSearchStore((state) => state.search_view_config);
  const removeSearchView = useGlobalSearchStore(
    (state) => state.removeSearchView,
  );
  const setPopup = usePopup();
  const { open, close, status } = useModalState();

  const configList = [...defaultGlobalSearchConfig, ...config];

  const removeSearchViewHandler = (view: GLOBAL_SEARCH_VIEW) => {
    setPopup({
      type: 'confirm',
      popupTheme: 'negative',
      title: 'Delete view',
      message: 'Are you sure you want to delete this view? ',
      onConfirm: () => {
        removeSearchView(view);
      },
    });
  };

  useFetch(syncSearchView);

  return (
    <>
      <SettingHeader title="Search" />
      <div className="p-8 gap-6 w-full flex flex-col">
        <Flex j="space-between">
          <VFlex g={8} f={1}>
            <SectionTitle>View list</SectionTitle>
            <MainText>
              Explore search results based on various feedback metadata. The
              views created are shared at the workspace level.
            </MainText>
          </VFlex>
          <Button variant="outlined" sizeType="m" onClick={() => open()}>
            Add view
          </Button>
        </Flex>
        <Table.Root className="h-full">
          <Table.Header>
            <Table.Col className="flex-1">Dataset</Table.Col>
            <Table.Col className="w-40">action</Table.Col>
          </Table.Header>
          <List
            data={configList}
            className="scrollbar-hide"
            render={(view) => {
              const target = GlobalSearchViewConfigMap.get(view);
              return (
                <Table.Row key={view} className="group">
                  <Table.Cell className="flex-1 ">{target?.name}</Table.Cell>
                  <Table.Cell className="w-40 group-hover:opacity-100 opacity-0 transition-opacity duration-200">
                    <Button
                      variant="error"
                      onClick={() => removeSearchViewHandler(view)}
                      disabled={defaultGlobalSearchConfig.includes(view)}
                    >
                      Delete
                    </Button>
                  </Table.Cell>
                </Table.Row>
              );
            }}
          />
        </Table.Root>
      </div>
      <Modal status={status} closeModal={close}>
        <AddSearchTabModal />
      </Modal>
    </>
  );
};

export default SearchSettingBody;
